import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Heading, Card } from '../theme/primitives';
import { iconMap } from '../theme/icons';
import { stonePalette } from '../theme/brand';
import ContactForm from './../components/ContactForm';
import requestConsultImg from '../assets/img/marketing/request-consult.jpg';

const CheckIcon = iconMap.check;

const TRUST_POINTS_KEYS = ['send_request.trust_0', 'send_request.trust_1', 'send_request.trust_2'];

const useStyles = makeStyles({
  root: { backgroundColor: stonePalette[50] },

  // Balta (ne paveldėta stonePalette[50]) — žr. #8: sekcija su nuotrauka
  // turi būti balta visuose šios struktūros puslapiuose.
  hero: {
    backgroundColor: tokens.colorNeutralBackground1,
    paddingTop: tokens.spacingVerticalXXL, paddingBottom: tokens.spacingVerticalXXXL,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  // Paddingas perkeltas ČIA (nuo `hero`) — kai maxWidth-centravimas IR
  // paddingas yra ANT SKIRTINGŲ elementų (išorinis full-bleed + vidinis
  // maxWidth+auto margin), susidaro DVIGUBAS centravimas, kuris duoda KITOKĮ
  // kairįjį atitraukimą nei header'io (kur abu — maxWidth IR paddingas — yra
  // ANT TO PATIES elemento). Sudėjus abu ant heroInner, formulė identiška
  // TopBar.jsx/MainMenu.jsx `container`, tad realiai lygiuojasi (žr.
  // /admin/bugs "Header logotipas ir language icon turi lygiuoti su
  // puslapio turiniu").
  heroInner: {
    maxWidth: '80rem', marginLeft: 'auto', marginRight: 'auto',
    paddingLeft: tokens.spacingHorizontalXXL, paddingRight: tokens.spacingHorizontalXXL,
    display: 'grid', gridTemplateColumns: '1fr', gap: tokens.spacingHorizontalXXL, alignItems: 'center',
    '@media (min-width: 900px)': { gridTemplateColumns: '1fr 1fr' },
    '@media (min-width: 1024px)': { paddingLeft: '3rem', paddingRight: '3rem' },
  },
  heroEyebrow: { marginBottom: tokens.spacingVerticalS },
  title: { marginBottom: tokens.spacingVerticalM },
  heroText: { fontSize: tokens.fontSizeBase400, color: tokens.colorNeutralForeground2, lineHeight: '1.6', marginBottom: tokens.spacingVerticalL, maxWidth: '32rem' },
  heroPoints: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalS },
  heroPoint: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalS, fontSize: tokens.fontSizeBase300, color: tokens.colorNeutralForeground1 },
  heroPointIcon: { color: tokens.colorBrandForeground2, fontSize: '18px', flexShrink: 0 },
  heroImageWrap: {
    borderRadius: tokens.borderRadiusXLarge, overflow: 'hidden', boxShadow: tokens.shadow16,
    aspectRatio: '4 / 3',
  },
  heroImage: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },

  section: {
    paddingTop: '4rem', paddingBottom: '4rem',
    paddingLeft: tokens.spacingHorizontalXXL, paddingRight: tokens.spacingHorizontalXXL,
  },
  sectionInner: { maxWidth: '48rem', marginLeft: 'auto', marginRight: 'auto' },
  card: { boxShadow: tokens.shadow8 },
});

function SendRequest() {
  const s = useStyles();
  const { t } = useTranslation();
  useEffect(() => { document.title = `${t('send_request.title')} | Fitit`; }, [t]);

  return (
    <div className={s.root}>
      {/* Hero — eyebrow/title/lead/trust taškai kairėje, atmosferos nuotrauka
          dešinėje, ta pati vizualinė kalba kaip /dovanu-cekis (GiftCard.jsx). */}
      <section className={s.hero}>
        <div className={s.heroInner}>
          <div>
            <Heading as="h1" variant="h1" className={s.title}>{t('send_request.title')}</Heading>
            <p className={s.heroText}>
              {t('send_request.lead')}
            </p>
            <div className={s.heroPoints}>
              {TRUST_POINTS_KEYS.map(key => (
                <div key={key} className={s.heroPoint}>
                  <CheckIcon className={s.heroPointIcon} />
                  {t(key)}
                </div>
              ))}
            </div>
          </div>
          <div className={s.heroImageWrap}>
            <img src={requestConsultImg} alt={t('send_request.img_alt')} className={s.heroImage} />
          </div>
        </div>
      </section>

      <section className={s.section}>
        <div className={s.sectionInner}>
          <Card className={s.card} padding={tokens.spacingHorizontalXXL}>
            <ContactForm hideHeader />
          </Card>
        </div>
      </section>
    </div>
  );
}

export default SendRequest;
